import { RefreshCw } from "lucide-react";
import { PageHeader } from "../PageHeader";
import { QueueTable } from "../shared/QueueTable";
import { securityRoomStore, selectHighRiskSessions } from "../../../stores/securityRoomStore";

function firstString(item: Record<string, unknown>, keys: string[]): string | undefined {
  for (const k of keys) {
    const v = item[k];
    if (typeof v === "string" && v) return v;
  }
  return undefined;
}

export function HighRiskPage() {
  const snap = securityRoomStore.useStore();
  const sessions = selectHighRiskSessions(snap, 70);

  return (
    <>
      <PageHeader
        title="High-risk sessions"
        subtitle={`${sessions.length} sessions over risk threshold`}
        actions={
          <button
            type="button"
            className="sr-btn sr-btn--ghost"
            onClick={() => window.location.reload()}
          >
            <RefreshCw size={14} /> Refresh
          </button>
        }
      />
      <div className="sr-page-body">
        <QueueTable
          events={sessions.map((raw, i) => {
            const s = raw as Record<string, unknown>;
            const id = typeof s.id === "string" ? s.id : `sess-${i}`;
            const ts =
              firstString(s, ["startedAt", "recordedAt", "lastSeenAt", "createdAt", "ts", "at"]) ??
              "";
            const agent = firstString(s, ["agent"]) ?? "";
            const score = typeof s.riskScore === "number" ? s.riskScore : null;
            const severity = score !== null && score >= 90 ? ("crit" as const) : ("deny" as const);
            const who =
              [agent, score !== null ? `risk: ${score}` : null].filter(Boolean).join(" · ") ||
              undefined;
            return {
              id,
              ts,
              severity,
              title: `Session ${id}`,
              who,
            };
          })}
          emptyMessage="No high-risk sessions in the last 24h"
          rowAction={(e) => (
            <a className="sr-event__open" href={`/workbench?session=${encodeURIComponent(e.id)}`}>
              Open
            </a>
          )}
        />
      </div>
    </>
  );
}
